module.exports = __webpack_public_path__ + "img/messenger.2030ee4a.png";